export default {
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: { margin: 2 },
  eventTemplateFormContainer: { marginBottom: '1rem' },
};

